import { cn } from "@ui/lib/utils";
import * as m from "motion/react-m";

interface CircleProgressIndicatorProps {
  className?: string;
  inverse?: boolean;
  progress: number;
}

export const CircleProgressIndicator = ({ progress, className, inverse }: CircleProgressIndicatorProps) => {
  const radius = 20;
  const ROTATE_DEGREES = 26;
  const circumference = 2 * Math.PI * radius;

  const remaining = 1 - progress;

  const padding = (ROTATE_DEGREES / 360) * circumference;
  const strokeDashoffset = circumference * remaining;
  const inverseDashoffset = -1 * (circumference - strokeDashoffset);

  const showProgress = circumference - strokeDashoffset > padding;
  const progressCircleOffset = strokeDashoffset + padding;
  const showInverseProgress = circumference - Math.abs(inverseDashoffset) > padding;
  const inverseProgressCircleOffset = inverseDashoffset - padding;

  return (
    <m.div
      animate={{ opacity: 1 }}
      className={cn("absolute flex items-center justify-center", className)}
      initial={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: "linear" }}
    >
      <svg className='h-16 w-16 -rotate-90 transform' viewBox='0 0 50 50'>
        {showProgress && (
          <m.circle
            animate={{ strokeDashoffset: progressCircleOffset, opacity: 1 }}
            className={cn("origin-center stroke-black", `rotate-[26deg]`, inverse && "stroke-white")}
            cx='25'
            cy='25'
            fill='transparent'
            initial={{ strokeDashoffset: circumference, opacity: 0 }}
            r={radius}
            strokeDasharray={circumference}
            strokeLinecap='round'
            strokeWidth='5'
            transition={{ duration: 0.3, ease: "linear" }}
          />
        )}
        {showInverseProgress && (
          <m.circle
            animate={{ strokeDashoffset: inverseProgressCircleOffset, opacity: 1 }}
            className='origin-center stroke-current text-lightest'
            cx='25'
            cy='25'
            fill='transparent'
            initial={{ strokeDashoffset: 0, opacity: 0 }}
            r={radius}
            strokeDasharray={circumference}
            strokeLinecap='round'
            strokeWidth='5'
            transition={{ duration: 0.3, ease: "linear" }}
          />
        )}
      </svg>
    </m.div>
  );
};
